import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('layout', {
    state: () => ({
        sidebarOpen: true,
        boot: false,
        ios: "https://apps.apple.com/br/app/pipeback-conversations/id6746337309",
        android: "https://play.google.com/store/apps/details?id=com.pipeback.app"
    }),

    actions: {
        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen
        },
    }
})